import { render } from "./AloneImage.vue?vue&type=template&id=0d37469e&scoped=true"
import script from "./AloneImage.vue?vue&type=script&lang=js"
export * from "./AloneImage.vue?vue&type=script&lang=js"

import "./AloneImage.vue?vue&type=style&index=0&id=0d37469e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d37469e"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d37469e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d37469e', __exports__)) {
    api.reload('0d37469e', __exports__)
  }
  
  module.hot.accept("./AloneImage.vue?vue&type=template&id=0d37469e&scoped=true", () => {
    api.rerender('0d37469e', render)
  })

}


export default __exports__